import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import StackView from '../StackView';
var Scrim = /*#__PURE__*/React.forwardRef(function (props, ref) {
  React.useLayoutEffect(function () {
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = '';
    };
  }, []);
  return /*#__PURE__*/React.createElement(StackView, _extends({
    innerRef: ref,
    position: "fixed",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 10000,
    overflow: "auto" // @ts-ignore
    ,
    backgroundColor: "hsla(0,0%,0%,0.74)"
  }, props));
});
export { Scrim };